import { ThemeInterface } from "injectors/theme";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: ThemeInterface) => ({
  detailsCategoryWrapper: {
    marginTop: 30,
  },
  detailsCategoryTitle: {
    fontSize: 15,
    fontWeight: 600,
  },
  detailsCategoryDescription: {
    color: theme.colors.darkGray.toString(),
    fontSize: 13,
    fontStyle: "italic",
    fontWeight: 400,
  },
  detailsCategoryRowsWrapper: {},
}));

export { useStyles };
